import { render } from "./ReceivePaymentReceiptPreviewModal.vue?vue&type=template&id=119bcb9a"
import script from "./ReceivePaymentReceiptPreviewModal.vue?vue&type=script&lang=js"
export * from "./ReceivePaymentReceiptPreviewModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__